import * as at from './actionTypes';

export const emailChanged = (text) => {
  return {
    type: at.EMAIL_CHANGED,
    payload: text
  };
};

export const passwordChanged = (text) => {
  return {
    type: at.PASSWORD_CHANGED,
    payload: text
  };
};



// WEBPACK FOOTER //
// ./src/scenes/Login/actions.js